import * as React from 'react';

import { Box } from '@lightspeed/flame/Core';

import { OrderLineTable } from 'root/apps/PurchaseOrder/NuorderOrdering/components/OrderLineTable';
import { PageHeader } from 'root/apps/PurchaseOrder/NuorderOrdering/components/PageHeader';
import { Summary } from 'root/apps/PurchaseOrder/NuorderOrdering/components/Summary';
import { useNuorderOrdering } from 'root/apps/PurchaseOrder/NuorderOrdering/context/Context';
import { useClearViewFunctions } from 'root/apps/PurchaseOrder/NuorderOrdering/context/useClearViewFunctions';
import { useClearViewTabs } from 'root/apps/PurchaseOrder/NuorderOrdering/context/useClearViewTabs';
import { useDataSequencer } from 'root/apps/PurchaseOrder/NuorderOrdering/context/useDataSequencer';

export const NuorderOrdering: React.FC = () => {
  const {
    state: { lastAction, purchase },
  } = useNuorderOrdering();

  useClearViewTabs(lastAction);
  useClearViewFunctions(purchase);
  useDataSequencer();

  return (
    <Box p={4} backgroundColor="gray-50" style={{ fontSize: '14px' }}>
      <PageHeader />
      <Summary />
      <OrderLineTable />
    </Box>
  );
};
